module.exports = __webpack_public_path__ + "static/media/rfid reader.12d7ecbe.jpg";